import ReactOnRails from 'react-on-rails';

import ResetPassword from 'tenants/cccsyd/auth/reset_password';
import SetPassword from 'tenants/cccsyd/auth/set_password';
import Login from 'tenants/cccsyd/auth/login';
import globalReact from './global-react';

ReactOnRails.register({
  ...globalReact,
  ResetPassword,
  SetPassword,
  Login,
});
